import { useEffect, useRef, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "../../../../utils/redux/store";
import MainPagetitle from "../../../layouts/MainPagetitle";
import DupeCheckModal from "../DupeCheck/DupeCheckModal";
import LoanDetailsSearch from "./LoanDetailsSearch/LoanDetailsSearch";
import { Radio } from "antd";

const LoanDetails = (props) => {
  const isAdmin = props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  const isUnderWriter =
    props?.$store?.persona === _enum.ROUTE_PERSONAS.underwriter;
  const isCollections =
    props?.$store?.persona === _enum.ROUTE_PERSONAS.collections;
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [rowcount, setRowcount] = useState(0);
  const [loanRemarks, setLoanRemarks] = useState([]);
  const infoForm = useRef(null);

  const disbursementColumns = [
    {
      dataIndex: "customerName",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">
              {record?.customerName}
            </h6>
          </div>
        );
      },
    },
    {
      dataIndex: "application",
      title: "Underwriter Name",
      render: (text, record) => {
        return (
          <div>
            <h6>{record?.underwriter?.name}</h6>
          </div>
        );
      },
    },
    // {
    //   dataIndex: "customer",
    //   title: "Customer Type",
    //   render: (text, record) => {
    //     return (
    //       <div>
    //         <h6>{record?.customer?.customerType?.toTitleCase() || "-"}</h6>
    //       </div>
    //     );
    //   },
    // },
    {
      dataIndex: "loanAccount",
      title: "LAN No.",
      render: (text, record) => {
        return <>{record?.loanAccount?.loanAccountNumber || "-"}</>;
      },
    },
    {
      dataIndex: "applicationType",
      title: "Application Type",
    },
    // {
    //   dataIndex: "appliedDevice",
    //   title: "Platform",
    // },
    {
      dataIndex: "sanctioned_amount",
      title: "Sanctioned amt.",
      render: (text, record) => {
        return (
          <>
            {record?.loanAccount?.sanctionedLoanAmount?.cur() || "-"}
          </>
        );
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "No. Of EMIs",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          return <>{record?.emiSchedules?.length || "-"}</>;
        } else {
          return <>{"-"}</>;
        }
      },
    },
    {
      dataIndex: "sanctionedLoanStartDate",
      title: "Loan Start Date",
      render: (text, record) => {
        if (record?.loanAccount?.sanctionedLoanStartDate) {
          let date = new Date(
            record?.loanAccount?.sanctionedLoanStartDate
          ).dateToDDMMYYYY(
            new Date(record?.loanAccount?.sanctionedLoanStartDate)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "EMI Start Date",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          let dateval = record?.emiSchedules[0]?.emiRepaymentDate;
          let date = new Date(dateval).dateToDDMMYYYY(new Date(dateval));
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "tenure",
      title: "Sanctioned Tenure",
      render: (text, record) => {
        return (
          <>{record?.loanAccount?.sanctionedLoanTenure || "-"}</>
        );
      },
    },
    {
      dataIndex: "roi",
      title: "ROI",
      render: (text, record) => {
        return (
          <>{`${record?.loanAccount?.sanctionedLoanIRR}%` || "-"}</>
        );
      },
    },
    {
      dataIndex: "processingFee",
      title: "Processing Fees",
      render: (text, record) => {
        return (
          <>{record?.loanAccount?.sanctionedLoanPF?.cur() || "-"}</>
        );
      },
    },
    // {
    //   dataIndex: "application",
    //   title: "Location",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {record?.application?.applicationAddressInfo?.filter(
    //           (v) => v?.addressType === "COMMUNICATION"
    //         )[0]?.city || "-"}
    //       </>
    //     );
    //   },
    // },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.status?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const pendingRestructureColumns = [
    {
      dataIndex: "borrowerName",
      title: "Customer Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">
              {record?.loanAccount?.borrowerName}
            </h6>
          </div>
        );
      },
    },
    {
      dataIndex: "application",
      title: "Underwriter Name",
      render: (text, record) => {
        return (
          <div>
            <h6>{record?.application?.underwriter?.name}</h6>
          </div>
        );
      },
    },
    // {
    //   dataIndex: "application",
    //   title: "Location",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {record?.application?.applicationAddressInfo?.filter(
    //           (v) => v?.addressType === "COMMUNICATION"
    //         )[0]?.city || "-"}
    //       </>
    //     );
    //   },
    // },
    // {
    //   dataIndex: "customer",
    //   title: "Customer Type",
    //   render: (text, record) => {
    //     return (
    //       <div>
    //         <h6>
    //           {record?.application?.customerApplicationType?.toTitleCase() ||
    //             "-"}
    //         </h6>
    //       </div>
    //     );
    //   },
    // },
    {
      dataIndex: "lan",
      title: "LAN No.",
      render: (text, record) => {
        return <>{record?.loanAccountNumber || "-"}</>;
      },
    },
    {
      dataIndex: "sanctionedLoanAmount",
      title: "Loan Amount",
      render: (text, record) => {
        return <>{record?.loanAccount?.sanctionedLoanAmount?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "restructureLoanStartDate",
      title: "Loan Start Date",
      render: (text, record) => {
        return text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-";
      },
    },
    {
      dataIndex: "restructureLoanEndDate",
      title: "Loan End Date",
      render: (text, record) => {
        return text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-";
      },
    },
    {
      dataIndex: "application",
      title: "Channel",
      render: (text, record) => {
        return <>{record?.application?.channel || "-"}</>;
      },
    },
    {
      dataIndex: "applicationType",
      title: "Application Type",
    },
    {
      dataIndex: "appliedDevice",
      title: "Platform",
    },
    {
      dataIndex: "loanAccountStatus",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.application?.status?.toLowerCase()] ||
          "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.application?.status?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "signzyLoanAgreementLink",
      title: "KFS",
      render: (text, record) => {
        return record?.isLoanAgreementSigned === true ? (
          <div className="docs_card">
            <a
              href={text}
              target="_blank"
              className="text-primary text-underline"
            >
              Download
            </a>
          </div>
        ) : (
          <>-</>
        );
      },
    },
    {
      dataIndex: "loanAccountStatus",
      title: "Loan Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[
          record?.loanAccount?.loanAccountStatus?.toLowerCase()
          ] || "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>
                {record?.loanAccount?.loanAccountStatus?.toTitleCase()}
              </span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "restructureStatus",
      title: "Restructured",
    },
  ];
  const activeColumns = [
    {
      dataIndex: "borrowerName",
      title: "Customer Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{record.borrowerName}</h6>
          </div>
        );
      },
    },
    // {
    //   dataIndex: "application",
    //   title: "Underwriter Name",
    //   render: (text, record) => {
    //     return (
    //       <div>
    //         <h6>{record?.application?.underwriter?.name}</h6>
    //       </div>
    //     );
    //   },
    // },
    {
      dataIndex: "application",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.application?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    // {
    //   dataIndex: "customer",
    //   title: "Customer Type",
    //   render: (text, record) => {
    //     return (
    //       <div>
    //         <h6>
    //           {record?.application?.customerApplicationType?.toTitleCase() ||
    //             "-"}
    //         </h6>
    //       </div>
    //     );
    //   },
    // },
    {
      dataIndex: "application",
      title: "Application Type",
      render: (text, record) => {
        return (
          <div>
            <h6>{record?.application?.customerApplicationType || "-"}</h6>
          </div>
        );
      },
    },
    {
      dataIndex: "application",
      title: "Platform",
      render: (text, record) => {
        return <>{record?.application?.appliedDevice || "-"}</>;
      },
    },
    {
      dataIndex: "lan",
      title: "LAN No.",
      render: (text, record) => {
        let t = isLoanOverdue(
          record?.loanAccountStatus,
          record?.sanctionedLoanEndDate
        );
        if (t) {
          return (
            <p className="d-flex align-items-center">
              <span className="rounded_text me-1">R</span>{" "}
              <span>{record?.loanAccountNumber}</span>
            </p>
          );
        } else {
          return record?.loanAccountNumber;
        }
      },
    },
    {
      dataIndex: "sanctionedLoanAmount",
      title: "Final Loan Amount",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "No. Of EMIs",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          return <>{record?.emiSchedules?.length || "-"}</>;
        } else {
          return <>{"-"}</>;
        }
      },
    },
    {
      dataIndex: "sanctionedLoanStartDate",
      title: "Loan Start Date",
      render: (text, record) => {
        return text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-";
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "EMI Start Date",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          let dateval = record?.emiSchedules[0]?.emiRepaymentDate;
          let date = new Date(dateval).dateToDDMMYYYY(new Date(dateval));
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "EMIs Received",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          let emisreceived = record?.emiSchedules?.filter(
            (v) => v.status === "COMPLETE"
          );
          return emisreceived?.length || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "sanctionedLoanEndDate",
      title: "Loan End Date",
      render: (text, record) => {
        return text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-";
      },
    },
    {
      dataIndex: "loanPaymentMode",
      title: "Payment Type",
    },
    // {
    //   dataIndex: "application",
    //   title: "Channel",
    //   render: (text, record) => {
    //     return <>{record?.application?.channel || "-"}</>;
    //   },
    // },
    {
      dataIndex: "principalComponent",
      title: "Principat Outstanding",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "interestComponent",
      title: "Interest",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "loanAccountStatus",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.application?.status?.toLowerCase()] ||
          "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.application?.status?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "signzyLoanAgreementLink",
      title: "KFS",
      render: (text, record) => {
        return record?.isLoanAgreementSigned === true ? (
          <div className="docs_card">
            <a
              href={text}
              target="_blank"
              className="text-primary text-underline"
            >
              Download
            </a>
          </div>
        ) : (
          <>-</>
        );
      },
    },
    {
      dataIndex: "status",
      title: "Loan Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.loanAccountStatus?.toLowerCase()] ||
          "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.loanAccountStatus?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const closedColumns = [
    {
      dataIndex: "borrowerName",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{record.borrowerName}</h6>
          </div>
        );
      },
    },
    // {
    //   dataIndex: "application",
    //   title: "Underwriter Name",
    //   render: (text, record) => {
    //     return (
    //       <div>
    //         <h6>{record?.application?.underwriter?.name}</h6>
    //       </div>
    //     );
    //   },
    // },
    {
      dataIndex: "application",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.application?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    // {
    //   dataIndex: "customer",
    //   title: "Customer Type",
    //   render: (text, record) => {
    //     return (
    //       <div>
    //         <h6>
    //           {record?.application?.customerApplicationType?.toTitleCase() ||
    //             "-"}
    //         </h6>
    //       </div>
    //     );
    //   },
    // },
    {
      dataIndex: "lan",
      title: "Application no",
      render: (text, record) => {
        return <>{record?.loanAccountNumber || "-"}</>;
      },
    },
    {
      dataIndex: "sanctionedLoanAmount",
      title: "Final Loan Amount",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "No. Of EMIs",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          return <>{record?.emiSchedules?.length || "-"}</>;
        } else {
          return <>{"-"}</>;
        }
      },
    },
    {
      dataIndex: "sanctionedLoanStartDate",
      title: "Loan Start Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "EMI Start Date",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          let dateval = record?.emiSchedules[0]?.emiRepaymentDate;
          let date = new Date(dateval).dateToDDMMYYYY(new Date(dateval));
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "emiSchedules",
      title: "EMIs Received",
      render: (text, record) => {
        if (record?.emiSchedules?.length > 0) {
          let emisreceived = record?.emiSchedules?.filter(
            (v) => v.status === "COMPLETE"
          );
          return emisreceived?.length || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "sanctionedLoanEndDate",
      title: "Loan End Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "tenure",
      title: "Tenure",
      render: (text, record) => {
        return <>{record?.sanctionedLoanTenure || "-"}</>;
      },
    },
    {
      dataIndex: "waiverAmount",
      title: "Waiver",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    // {
    //   dataIndex: "application",
    //   title: "Channel",
    //   render: (text, record) => {
    //     return <>{record?.application?.channel || "-"}</>;
    //   },
    // },
    {
      dataIndex: "totalRepaymentAmtTillDate",
      title: "Total Paid Amount",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "loanClosingDate",
      title: "Loan Closer Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
  ];
  const loanSettlementColumns = [
    {
      dataIndex: "borrowerName",
      title: "Customer Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{record.borrowerName}</h6>
          </div>
        );
      },
    },
    {
      dataIndex: "application",
      title: "Underwriter Name",
      render: (text, record) => {
        return (
          <div>
            <h6>{record?.application?.underwriter?.name}</h6>
          </div>
        );
      },
    },
    {
      dataIndex: "application",
      title: "Location",
      render: (text, record) => {
        return (
          <>
            {record?.application?.applicationAddressInfo?.filter(
              (v) => v?.addressType === "COMMUNICATION"
            )[0]?.city || "-"}
          </>
        );
      },
    },
    {
      dataIndex: "lan",
      title: "LAN No.",
      render: (text, record) => {
        let t = isLoanOverdue(
          record?.loanAccountStatus,
          record?.sanctionedLoanEndDate
        );
        if (t) {
          return (
            <p className="d-flex align-items-center">
              <span className="rounded_text me-1">R</span>{" "}
              <span>{record?.loanAccountNumber}</span>
            </p>
          );
        } else {
          return record?.loanAccountNumber;
        }
      },
    },
    {
      dataIndex: "sanctionedLoanAmount",
      title: "Final Loan Amount",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "sanctionedLoanStartDate",
      title: "Loan Start Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "sanctionedLoanEndDate",
      title: "Loan End Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "sanctionedLoanTenure",
      title: "Tenure",
      render: (text, record) => {
        return <>{text || "-"}</>;
      },
    },
    {
      dataIndex: "settlement_amount",
      title: "Settlement Amount",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "writeOffAmount",
      title: "Write-Off Amount",
      render: (text, record) => {
        return <>{text?.cur() || "-"}</>;
      },
    },
    {
      dataIndex: "loanAccountStatus",
      title: "Status",
      render: (text, record) => {
        return (
          <AppTag color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
  ];
  const [columns, setColumns] = useState(disbursementColumns);
  const [activeKey, setActiveKey] = useState("");
  const filterTabData = [
    {
      key: "pending",
      name: "Pending for Disbursement",
    },
    {
      key: "pendingrestructure",
      name: "Pending Restructure Loan",
    },
    {
      key: "active",
      name: "Active Loans",
    },
    {
      key: "closed",
      name: "Closed Loans",
    },
    {
      key: "loansettlements",
      name: "Write Off / Settlement Loans",
    },
  ];

  const handleSelect = (e, key) => {
    let payload = {
      page: 1,
      limit: 10,
    };
    setSearch(payload);
    setActiveKey(key);
    navigate(
      `/app/loandetails?activetab=${key}&producttype=${activeProductType}`
    );
  };

  const onPageChange = (pageData) => {
    setSearch((prevState) => ({
      ...prevState,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    }));
  };

  const isLoanOverdue = (status, sanctionedLoanEndDate) => {
    // console.log({ status, sanctionedLoanEndDate });

    if (status !== "OVERDUE") return false;

    const endDate = new Date(sanctionedLoanEndDate);
    const now = new Date();

    // Difference in days
    const diffInTime = now.getTime() - endDate.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);
    return diffInDays > 90;
  };

  const getPendingDisbursedApplications = (params = {}) => {
    let payload = { ...params };

    props.apis
      .apiGetAllUnderWriterPredisbursedApplications(payload)
      .then(async ({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const getPendingRestructureApplications = (params = {}) => {
    let payload = { ...params };

    props.apis
      .apiGetPendingLoanRestructureRequests(payload)
      .then(({ data, total }) => {
        console.log({ data });
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const getActiveApplications = (params = {}) => {
    let payload = { ...params };

    props.apis.apiGetAllActiveLoans(payload).then(({ data, total }) => {
      console.log({ data });
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const getLoanRemarks = (lan) => {
    let payload = {
      loanAccountNumber: lan,
    };

    props.apis.apiGetLoanRemarks(payload).then((res) => {
      setLoanRemarks(res);
    });
  };

  const getClosedApplications = (params = {}) => {
    let payload = { ...params };

    props.apis.apiGetAllClosedLoans(payload).then(({ data, total }) => {
      console.log({ data });
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const getLoanSettlements = (params = {}) => {
    let payload = { ...params };

    setTableData([]);
    setIsFetching(false);
    setRowcount(0);

    props.apis.apiGetAllWriteOffSettlements(payload).then(({ data, total }) => {
      console.log({ data });
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const edit = (record) => {
    console.log({ record });
    let { loanAccount } = record;
    let path;
    if (activeKey === "pending") {
      path = `/app/loandetailspendingview?id=${loanAccount?.applicationId}&lanid=${loanAccount?.loanAccountNumber}&name=${loanAccount?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails`;
    } else if (activeKey === "pendingrestructure") {
      path = `/app/loandetailspendingrestructureview?id=${record?.applicationId}&lanid=${record?.loanAccountNumber}&name=${record?.loanAccount?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails`;
    } else if (activeKey === "active") {
      path = `/app/loandetailsactiveview?id=${record?.applicationId}&lanid=${record?.loanAccountNumber}&name=${record?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails`;
    } else if (activeKey === "closed") {
      setSelectedLan(record);
      setShowReloanModal(true);
    }
    navigate(path);
  };

  const view = (record) => {
    console.log({ record });
    let { loanAccount } = record;

    let path;
    if (activeKey === "pending") {
      path = `/app/loandetailspendingview?id=${loanAccount?.applicationId}&lanid=${loanAccount?.loanAccountNumber}&name=${loanAccount?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails&readonly=true`;
    } else if (activeKey === "pendingrestructure") {
      path = `/app/loandetailspendingrestructureview?id=${record?.applicationId}&lanid=${record?.loanAccountNumber}&name=${record?.loanAccount?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails&readonly=true`;
    } else if (activeKey === "active") {
      path = `/app/loandetailsactiveview?id=${record?.applicationId}&lanid=${record?.loanAccountNumber}&name=${record?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails&readonly=true`;
    } else if (activeKey === "closed") {
      path = `/app/loandetailsclosedview?id=${record?.applicationId}&lanid=${record?.loanAccountNumber}&name=${record?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails&readonly=true`;
    } else if (activeKey === "loansettlements") {
      path = `/app/loandetailswriteoffview?id=${record?.applicationId}&lanid=${record?.loanAccountNumber}&name=${record?.borrowerName}&status=${activeKey}&producttype=${activeProductType}&frompath=loandetails&readonly=true`;
    }
    navigate(path);
  };

  // ----------------------------------------------------------------
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupdata, setPopupdata] = useState({});

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const onModalClose = () => {
    closeModal();
    setPopupdata([]);
  };
  const viewApplLogs = (record) => {
    let { applicationId } = record;
    let payload = {
      applicationId,
    };
    props.apis
      .apiGetUnderwriterApplicationApplicationHistory(payload)
      .then((res) => {
        setPopupdata(res);
        setOpenCanvas(true);
      });
  };

  const handleManualDisbursement = (record) => {
    console.log({ record });
    let { applicationId, loanAccountNumber, borrowerName } =
      record?.loanAccount;
    let path = `/app/manualdisbursementview?id=${applicationId}&lanid=${loanAccountNumber}&name=${borrowerName}&status=${activeKey}&producttype=${activeProductType}`;
    navigate(path);
  };

  const updatePendingRecord = (record) => {
    let id = record?.loanAccount.payoutTransactions[0].referenceId;

    props.apis.apiCheckYesBankFtxPaymentStatus({ bankRefId: id }).then((res) => {
      console.log({ res });
      if (res) {
        swal2.fire({
          title: `Disbursement for this transaction is '${res?.data?.ftxGetStatusResp?.data?.txnStatus}'`,
          icon: 'success',
          iconColor: '#BB1766',
          showCancelButton: false,
          timer: 4000,
        });
        getData();
      }
    });
  };

  // ----------------------------------------------------------------

  const handleRejectReview = (record) => {
    console.log({ record });

    swal2
      .fire({
        title:
          "Are you sure you want to reject the application?\n Please provide your remarks",
        icon: "info",
        iconColor: "#BB1766",
        html: '<div id="custom-select-container"></div>',
        showCancelButton: true,
        confirmButtonColor: "#BB1766",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: {
          htmlContainer: "rejected_html_container",
          actions: "rejected_actions",
        },
      })
      .then((result) => {
        console.log({ result });
        if (result.isConfirmed) {
          let reasonSelectValue = document.querySelector(
            "[name='appinput-reasons'].form-group"
          )?.vnode.refs.select?.state.values[0]?.key;

          let otherReasonValue =
            document.querySelector("#reasonsremarks").value;

          let payload = {};

          if (reasonSelectValue === "OTHERS") {
            payload.rejectedReason = otherReasonValue;
          } else {
            payload.rejectedReason = reasonSelectValue;
          }

          console.log({ payload }, record.loanAccount.applicationId);

          props.apis
            .apiUnderWriterRejectApplication(payload, {
              applicationId: record.loanAccount.applicationId,
            })
            .then((res) => {
              swal2.fire({
                title: "Application Rejected",
                icon: "success",
                iconColor: "#BB1766",
                showCancelButton: false,
                timer: 3000,
              });
              navigate(`/app/loanapplications?activetab=approved`);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    let container = document.getElementById("custom-select-container");
    let root = createRoot(container);
    root.render(
      <Provider store={store}>
        <AppInput
          name="reasons"
          label="Rejected Reasons"
          type="select"
          options={_enum.REJECTED_REASONS}
          onChange={(...args) => handleRejectedReasons(...args)}
          required={true}
        ></AppInput>
        <AppInput
          id="reasonsremarks"
          name="remarks"
          label="Remarks"
          type="textarea"
          required={true}
          outerclass="d-none"
        ></AppInput>
      </Provider>
    );
  };

  const handleRejectedReasons = (val) => {
    let reason = val[0]?.key;
    console.log({ reason });
    if (reason === "OTHERS") {
      document
        .querySelector('[name="appinput-remarks"]')
        .classList.remove("d-none");
    } else {
      document
        .querySelector('[name="appinput-remarks"]')
        .classList.add("d-none");
    }
  };
  // ----------------------------------------------------------------

  const [show, setShow] = useState(false);
  const [currentNoc, setCurrentNoc] = useState({});

  const handleClose = () => setShow(false);

  const handleShow = (record) => {
    setShow(true);
    setCurrentNoc(record);
  };

  const generateNOC = () => {
    let payload = {
      loanAccountNumber: currentNoc?.loanAccountNumber,
    };
    props.apis.apiGenerateNocToCustomer(payload).then((res) => {
      if (res) {
        swal2.fire({
          title: "NOC Generated Successfully",
          icon: "success",
          iconColor: "#BB1766",
          timer: 3000,
          confirmButtonText: "Close",
        });
        handleClose();
      }
    });
  };

  const handleViewLogs = (record) => {
    console.log({ viewLogs: record });
  };

  // ----------------------------------------------------------------
  const [showReloanModal, setShowReloanModal] = useState(false);
  const [selectedLan, setSelectedLan] = useState(null);
  const [reloanFields, setReloanFields] = useState([
    {
      name: "reLoanEligibility",
      label: "Case is eligible for Re-loan?(Y/N)",
      type: "select",
      options: _enum.YES_OR_NO_BOOLEAN,
    },
    {
      name: "channel",
      label: "Source Type",
      type: "select",
      options: _enum.SOURCING_CHANNELS,
      onChange: (...args) => handleSourcingChannelChange(...args),
    },
    {
      name: "dsaName",
      label: "DSA Name",
      type: "text",
      outerclass: "d-none col-xl-6 mb-3 w-100 d-flex flex-column",
    },
    {
      name: "telecallerId",
      label: "Tele caller Name",
      type: "select",
      options: [],
    },
  ]);

  const getAllTelecallers = () => {
    props.apis.apiGetEmployee({ role: "SALES" }).then(({ data, total }) => {
      console.log({ data });

      let formFields = reloanFields?.map((field) => {
        return field;
      });
      let telecallerNameField = formFields.find(
        (field) => field.name === "telecallerId"
      );
      telecallerNameField.options = data.options("profileId", "name");

      console.log({ formFields });
      setReloanFields([...formFields]);
    });
  };

  const handleReloanClose = () => setShowReloanModal(false);

  const handleSourcingChannelChange = (args) => {
    let soruceType = args[0]?.key;
    console.log({ soruceType });
    let inputs = ["dsaName"];
    if (soruceType === "DSA") {
      showInputs(inputs);
    } else {
      hideInputs(inputs);
    }
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      console.log(inputnames);
      inputnames.forEach((id) => {
        const element = document.querySelector(`[name="appinput-${id}"]`);

        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      console.log({ inputnames });

      inputnames.forEach((id) => {
        const element = document.querySelector(`[name="appinput-${id}"]`);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleReloan = (record) => {
    setSelectedLan(record);
    setShowReloanModal(true);

    console.log({ record });

    setTimeout(() => {
      let el = document.querySelector(`[name="appinput-dsaName"]`);
      let channel = record?.application?.channel;

      if (channel === "DSA") {
        el.classList.remove("d-none");
      } else {
        el.classList.add("d-none");
      }
    }, 100);

    let formFields = reloanFields?.map((field) => {
      return field;
    });
    let reLoanEligibilityField = formFields.find(
      (field) => field.name === "reLoanEligibility"
    );
    let channelField = formFields.find((field) => field.name === "channel");

    // reLoanEligibilityField.defaultValue = record?.customer?.reLoanEligibility;
    channelField.defaultValue = record?.application?.channel;

    setReloanFields([...formFields]);
  };

  const handleReloanSubmit = (e, data) => {
    console.log({ data, selectedLan });
    if (data?.reLoanEligibility !== "") {
      let payload = {
        reLoanEligibility: data?.reLoanEligibility
          ? JSON.parse(data?.reLoanEligibility)
          : "",
      };

      let urlData = {
        customerId: selectedLan?.customerId,
      };

      console.log({ urlData, payload });

      props.apis.apiAdminUpdateCustomerDetails(payload, urlData).then((res) => {
        if (res) {
          setShowReloanModal(false);
          getData();
        }
      });
    }

    // ---------------------------
    let payload2 = {
      ...Object.except(data, "reLoanEligibility"),
    };
    props.apis
      .apiUnderWriterUpdateApplWithoutStatus(payload2, {
        applicationId: selectedLan?.applicationId,
      })
      .then((res) => {
        if (res) {
          setShowReloanModal(false);
          getData();
        }
      });
  };
  // ----------------------------------------------------------------
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [remarksFields, setRemarksFields] = useState([
    {
      name: "remarks",
      label: "Remarks",
      type: "textarea",
      required: true,
    },
  ]);
  const handleRemarksClose = () => setShowRemarksModal(false);

  const handleRemarks = (record) => {
    setSelectedLan(record);
    setShowRemarksModal(true);
    getLoanRemarks(record?.loanAccountNumber);
  };

  const handleRemarksSubmit = (e, data) => {
    let payload = {
      loanAccountNumber: selectedLan?.loanAccountNumber,
      remarks: data?.remarks,
    };

    swal2.fire({
      title: "Remarks added Successfully",
      icon: "success",
      iconColor: "#BB1766",
      timer: 4000,
    });
    setSelectedLan(null);
    setShowRemarksModal(false);
    props.apis.apiAddLoanRemarks(payload).then((res) => {
      if (res) {
        setShowRemarksModal(false);
      }
    });
  };
  // ----------------------------------------------------------------

  const downloadLoanDetails = () => {
    let payload = {};
    if (activeKey === "closed") {
      payload.status = activeKey?.toUpperCase();
    } else {
      payload.status = `${activeKey?.toUpperCase()},OVERDUE`;
    }
    payload.loanPaymentMode = activeProductType;

    let startDateValue = document.querySelector("[name='startDate']")?.value;
    let endDateValue = document.querySelector("[name='endDate']")?.value;

    if (startDateValue) {
      payload.startDate = startDateValue;
    }
    if (endDateValue) {
      payload.endDate = endDateValue;
    }

    if ((isAdmin || isCollections) && activeKey === "active") {
      delete payload.loanPaymentMode;
    }

    if ((isAdmin || isCollections) && activeKey === "closed") {
      delete payload.loanPaymentMode;
    }

    if (search?.status === "OVERDUE") {
      payload.status = "ACTIVE,OVERDUE";
    }

    props.apis.apiExportLoanDetails(payload).then(async (res) => {
      // console.log({ res });
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute(
          "download",
          `loan_details_${new Date().toDate()}.xlsx`
        );
        // console.log(link);
        link.click();
      }
    });
  };

  const handleSettlementDownload = (record) => {
    let payload = {
      loanAccountNumber: record?.loanAccountNumber,
    };
    props.apis.apiDownloadSettlementPdf(payload).then(async (res) => {
      // console.log({ res });
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/pdf",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `settlement_${new Date().toDate()}.pdf`);
        // console.log(link);
        link.click();
      }
    });
  };

  // ----------------------------------------------------------------

  const handleLocationHistory = (record) => {
    console.log({ record });
    if (record?.customerId) {
      let link = `/app/locationhistory?applId=${record?.applicationId}&customerId=${record?.customerId}&customerName=${record?.borrowerName}&frompath=loanDetails`;
      navigate(link);
    } else {
      swal2.fire({
        title: "Customer ID not found",
        icon: "error",
        iconColor: "#BB1766",
        showCancelButton: false,
        timer: 3000,
      });
    }
  };

  // ----------------------------------------------------------------
  const [activeProductType, setActiveProductType] = useState("BULLET");
  const handleProductTypeChange = (e) => {
    let value = e.target.value;
    setActiveProductType(value);
    navigate(`/app/loandetails?activetab=${activeKey}&producttype=${value}`);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };
  // ----------------------------------------------------------------

  const getData = (payload) => {
    // clear table data from previous request
    setTableData([]);

    if (activeKey === "pending") {
      // console.log({ activeProductType });

      // filter disbursement columns based on product type
      let excluded =
        activeProductType === "BULLET"
          ? [
            "sanctionedNoOfMonth",
            "sanctionedEMIDate",
            "sanctionedTenure",
            "emiSchedules",
          ]
          : [];
      let alteredDisburementColumns = filterColumns(
        disbursementColumns,
        excluded
      );
      // payload.applicationType = "REGULAR";
      setColumns(alteredDisburementColumns);
      getPendingDisbursedApplications(payload);
    } else if (activeKey === "pendingrestructure") {
      // console.log({ activeProductType });

      // filter pendingrestructure columns based on product type
      // payload.applicationType = "RE_STRUCTURE";

      setColumns(pendingRestructureColumns);
      getPendingDisbursedApplications(payload);
    } else if (activeKey === "active") {
      // console.log({ activeProductType });

      // filter active columns based on product type
      let excluded =
        activeProductType === "BULLET"
          ? [
            "sanctionedNoOfMonth",
            "sanctionedEMIDate",
            "sanctionedTenure",
            "emiSchedules",
          ]
          : ["sanctionedLoanEndDate"];
      let alteredActiveColumns = filterColumns(activeColumns, excluded);

      setColumns(alteredActiveColumns);
      getActiveApplications(payload);
    } else if (activeKey === "closed") {
      // console.log({ activeProductType });

      // filter closed columns based on product type
      let excluded =
        activeProductType === "BULLET"
          ? [
            "sanctionedNoOfMonth",
            "sanctionedEMIDate",
            "sanctionedTenure",
            "emiSchedules",
          ]
          : ["sanctionedLoanEndDate", "tenure"];
      let alteredClosedColumns = filterColumns(closedColumns, excluded);

      setColumns(alteredClosedColumns);
      getClosedApplications(payload);
    } else if (activeKey === "loansettlements") {
      setColumns(loanSettlementColumns);
      getLoanSettlements(payload);
    }
  };

  const filterColumns = (columns, excludedFields = []) => {
    return columns.filter((col) => !excludedFields.includes(col.dataIndex));
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on loan details", data, reset);
    let defaultSearchData = Object.only(data, ["limit", "page"]);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
    }
    setSearch(payload);
  };

  const onTableSearch = (e, data, reset = false) => {
    e.preventDefault();
    let payload = {
      ...Object.filter(data, (val) => val),
      page: 1,
      limit: 10,
    };
    setSearch(payload);
  };

  const resetTableSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let defaultSearchData = Object.only(search, ["limit", "page"]);
    let payload = {
      ...defaultSearchData,
    };
    setSearch(payload);
  };

  useEffect(() => {
    setColumns([]);
    setTableData([]);
    setRowcount(0);

    let payload = {
      ...search,
      paymentType: activeProductType,
    };

    const str = window.location.search;
    const params = Object.fromEntries(new URLSearchParams(str));
    console.log({ params });

    if (params.hasOwnProperty("status")) {
      payload.status = params?.status;
    } else if (params.hasOwnProperty("channel")) {
      payload.channel = params?.channel;
    }

    if (params.hasOwnProperty("emiFilter")) {
      payload.emiFilter = params?.emiFilter;
    }

    console.log({ payload, search });
    getData(payload);
  }, [activeKey, search]);

  useEffect(() => {
    let paramsActiveTab = props.urlparams.params.activetab;
    let paramsProductType = props.urlparams.params.producttype || "BULLET";
    if (paramsProductType) {
      setActiveProductType(paramsProductType);
    }
    if (paramsActiveTab) {
      setActiveKey(paramsActiveTab);
    } else if (isCollections) {
      setActiveKey("active");
      navigate(
        `/app/loandetails?activetab=active&producttype=${paramsProductType}`
      );
    } else {
      setActiveKey("pending");
      navigate(
        `/app/loandetails?activetab=pending&producttype=${paramsProductType}`
      );
    }
    // scroll page to top
    window.scrollTo(0, 0);
    getAllTelecallers();
  }, []);

  // ----------------------
  const commonLocationHistory = {
    locationHistoryLink: ["pending", "active", "closed"].includes(activeKey),
    viewLocationHistoryAction: handleLocationHistory,
  };

  const getAdminProps = () => {
    switch (activeKey) {
      case "pending":
        return {
          viewable: true,
          editable: true,
          deletable: false,
          updateable: true,
          manualDisbursement: true,
          rejectReasonLink: true,
          viewAction: view,
          editAction: edit,
          updateAction: updatePendingRecord,
          manualDisbursementAction: handleManualDisbursement,
          rejectReasonLinkAction: handleRejectReview,
        };
      case "pendingrestructure":
        return {
          viewable: true,
          editable: true,
          deletable: false,
          viewAction: view,
          editAction: edit,
          ...commonLocationHistory,
        };
      case "active":
        return {
          viewable: true,
          editable: true,
          deletable: false,
          appllogLink: true,
          remarksLink: true,
          viewApplLogsAction: viewApplLogs,
          viewRemarksAction: handleRemarks,
          editAction: edit,
          ...commonLocationHistory,
        };
      case "closed":
        return {
          viewable: true,
          editable: false,
          deletable: false,
          appllogLink: true,
          remarksLink: true,
          issueNocLink: true,
          reloanLink: true,
          viewApplLogsAction: viewApplLogs,
          viewRemarksAction: handleRemarks,
          issueNocLinkAction: handleShow,
          reloanLinkAction: handleReloan,
          ...commonLocationHistory,
        };
      case "loansettlements":
        return {
          viewable: true,
          editable: false,
          deletable: false,
          downloadSettlement: true,
          downloadSettlementAction: handleSettlementDownload,
          ...commonLocationHistory,
        };
      default:
        return {};
    }
  };

  const getUnderwriterProps = () => ({
    viewable: true,
    editable: false,
    deletable: false,

    ...(["active"].includes(activeKey)
      ? {
        appllogLink: true,
        remarksLink: true,
        viewRemarksAction: handleRemarks,
        viewApplLogsAction: viewApplLogs,
      }
      : [("active", "closed")].includes(activeKey)
        ? {
          appllogLink: true,
          viewApplLogsAction: viewApplLogs,
        }
        : activeKey === "pending"
          ? {
            viewAction: view,
          }
          : {}),
  });

  const getCollectionsProps = () => {
    if (activeKey === "active") {
      return {
        viewable: true,
        editable: false,
        deletable: false,
        remarksLink: true,
        viewRemarksAction: handleRemarks,
        ...commonLocationHistory,
      };
    }
    if (activeKey === "closed") {
      return {
        viewable: true,
        editable: false,
        deletable: false,
        remarksLink: true,
        viewRemarksAction: handleRemarks,
        ...commonLocationHistory,
      };
    }
    if (activeKey === "loansettlements") {
      return {
        viewable: true,
        viewAction: view,
        editable: false,
        deletable: false,
        remarksLink: false,
        ...commonLocationHistory,
      };
    }
    return {};
  };

  const appTablePermissionProps = (() => {
    if (isAdmin) return getAdminProps();
    if (isUnderWriter) return getUnderwriterProps();
    if (isCollections) return getCollectionsProps();
    return {};
  })();

  props.$setNode({
    props,
    search,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Loan details"
        parentTitle={"Home"}
        pageIcon={imagepaths.fileCircleCheckIconActive}
      />
      <div className="container-fluid">
        <div className="header_radio_container">
          <p>Product Type</p>
          <Radio.Group
            name="radiogroup"
            defaultValue={props.urlparams.params.producttype || "BULLET"}
            options={[
              { value: "BULLET", label: "Bullet" },
              { value: "EMI", label: "EMI" },
            ]}
            onChange={(...args) => handleProductTypeChange(...args)}
          />
        </div>
        <div
          className={Object.className({
            filter_tab_container: true,
            // "d-none": isCollections ? true : false,
          })}
        >
          {filterTabData
            ?.filter((v) => (isCollections ? v.key !== "pending" : v))
            ?.map((btn) => {
              return (
                <>
                  <button
                    type="button"
                    id={btn.key}
                    className={Object.className({
                      active: activeKey === btn.key,
                    })}
                    onClick={(...args) => handleSelect(...args, btn.key)}
                  >
                    {btn.name}
                  </button>
                </>
              );
            })}
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <div className="tbl-caption-container p-0 justify-content-end mb-5">
                  {isCollections && (
                    <div className="header_btn_box my-3">
                      <a
                        className="btn btn-sm btn-outline-secondary me-2"
                        onClick={(...args) => downloadLoanDetails(...args)}
                      >
                        <i className="fa fa-download me-2"></i>
                        <span>Bulk Download</span>
                      </a>
                    </div>
                  )}

                  {!["pendingrestructure", "pending"].includes(activeKey) && (
                    <AppForm
                      ref={infoForm}
                      onSubmit={(...args) => onTableSearch(...args)}
                    >
                      <div className="form_input_container px-5">
                        <div className="grid_item">
                          <AppInputFocus
                            name="customerName"
                            label="Name"
                            type="text"
                            placeholder="Name"
                          ></AppInputFocus>
                        </div>
                        <div className="grid_item">
                          <AppInputFocus
                            name="mobileNumber"
                            label="Phone No"
                            type="text"
                            placeholder="Phone No"
                          ></AppInputFocus>
                        </div>
                        <div className="grid_item">
                          <AppInputFocus
                            name="pan"
                            label="PAN Number"
                            type="text"
                            placeholder="PAN Number"
                          ></AppInputFocus>
                        </div>
                        <div className="grid_item has_float_btn">
                          <AppInputFocus
                            name="loanAccountNumber"
                            label="Loan Account Number"
                            type="text"
                            placeholder="Loan Account Number"
                          ></AppInputFocus>

                          <button
                            type="button"
                            className="btn table_reset_btn"
                            onClick={(...args) => resetTableSearchForm(...args)}
                          >
                            Clear Filter
                          </button>
                        </div>
                        <div className="grid_item">
                          <button
                            type="submit"
                            className="btn table_search_btn"
                          >
                            <i className="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                    </AppForm>
                  )}

                  <div
                    className={Object.className({
                      "header_btn_box my-3 mw-fit": true,
                      hidden:
                        !isAdmin ||
                        (activeKey !== "active" &&
                          activeKey !== "closed" &&
                          activeKey !== "loansettlements"),
                    })}
                  >
                    <a
                      className="btn btn-sm btn-outline-secondary me-2"
                      onClick={(...args) => downloadLoanDetails(...args)}
                    >
                      <i className="fa fa-download me-2"></i>
                      <span>Bulk Download</span>
                    </a>
                  </div>
                  <LoanDetailsSearch
                    onSearch={(...arg) => onSearch(...arg)}
                    activeKey={activeKey}
                  />
                </div>

                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  viewAction={(e) => view(e)}
                  {...appTablePermissionProps}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DupeCheckModal
        title="Application Log"
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
      />
      {/* PREVIEW MODAL */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        className="preview_agreement_modal noc_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="py-0">
          <div className="heading_box">
            <Modal.Title>Shatabdi Loans</Modal.Title>
            <Modal.Title>No Objection Certificate</Modal.Title>
          </div>
          <p className="date">
            Date : <span>{new Date().dateToDDMMYYYY(new Date())}</span>
          </p>
          <p className="loanNum">
            Loan No. : <span>{currentNoc?.loanAccountNumber}</span>
          </p>
          <br />
          <br />
          <p className="para_title">Mr/Ms</p>
          <p className="paragraph_text">
            This is to certify that <span>{currentNoc?.borrowerName}</span> who
            had taken a short-term loan from Shatabdi Loans
            Limited for Rs.
            <span>{currentNoc?.sanctionedLoanAmount?.cur()}</span>. on
            <span>
              {new Date(currentNoc?.sanctionedLoanStartDate).dateToDDMMYYYY(
                new Date(currentNoc?.sanctionedLoanStartDate)
              )}
            </span>
            has fully repaid the loan amount. Hence there are no more dues from
            Mr/Ms. <span>{currentNoc?.borrowerName}</span> against this loan
            taken from Shatabdi Loans.
          </p>
          <br />
          <br />

          <img src={imagepaths.nocLogo} width={150} height={150} alt="Shatabdi Stamp" />
          <br />
          <br />

          <div className="contact_box_container">
            <div className="contact_box">
              <i className="fa-solid fa-phone"></i>
              <span>+91 9319688002 / +91 9217250081</span>
            </div>
            <div className="contact_box mx-3">
              <i className="fa-solid fa-envelope"></i>
              <span>info@shatabdiloans.com</span>
            </div>
            <div className="contact_box">
              <i className="fa-solid fa-globe"></i>
              <span>https://shatabdi.com</span>
            </div>
          </div>

          <div className="card_footer mt-4 text-center">
            <p className="fw-bold">Shatabdi Loans</p>
            <p>Office No. 155, Build on 1 Floor, Situated at Plot No. 2 Vardhman City, Centre Gulabi Bagh/Shakti Nagar, Delhi 110052</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary-lite"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={(...args) => generateNOC(...args)}
          >
            Generate
          </button>
        </Modal.Footer>
      </Modal>

      {/* RELOAN MODAL */}
      <Modal
        show={showReloanModal}
        onHide={(...args) => handleReloanClose(...args)}
        className="customer_application_modal br-normal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Re-loan</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleReloanSubmit}>
            {reloanFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(...args) => handleReloanClose(...args)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>

      {/* REMARKS MODAL */}
      <Modal
        show={showRemarksModal}
        onHide={(...args) => handleRemarksClose(...args)}
        className="customer_application_modal br-normal remarks_modal"
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Remarks</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleRemarksSubmit}>
            {remarksFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <div className="d-flex justify-content-end">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </AppForm>
          <div
            className={Object.className({
              remarks_history_container: true,
              "mt-4": isCollections,
            })}
          >
            <h3>Remark History</h3>
            <div className="remarks_lists">
              {loanRemarks &&
                loanRemarks?.map(({ createdAt, createdByName, remarks }) => {
                  return (
                    <div className="remarks_card">
                      <h4 className="">
                        {createdByName} :(
                        {new Date(createdAt).toLocaleDateString()})
                      </h4>
                      <p>{remarks}</p>
                    </div>
                  );
                })}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(LoanDetails);
